var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',{staticClass:"moomin-button--full-width",attrs:{"ariaLabel":_vm.buttonText},on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }